<app-dialog-header [title]="createNew ? 'New facility' : 'Edit facility'"></app-dialog-header>
<app-add-edit-facility
  [facility]="data"
  [submitText]="createNew ? 'Create' : 'Save'"
  (facilitySubmitted)="Submit($event)"
  (cancel)="closeDialog()"
>
</app-add-edit-facility>
